import { useEffect } from 'react';
import { Envelope } from '../Envelope/Envelope';
import styles from './app.module.css';
import Snowfall from 'react-snowfall';
import ym, { YMInitializer } from 'react-yandex-metrika';

function App() {

  useEffect(() => {
    // Проверка наличия объекта ym перед его использованием
    // if (window.ym) {
    //     window.ym(95940102, 'reachGoal', 'user_login');
    // }
      if (typeof ym === 'function') {
        ym('reachGoal', 'user_login');
      } else {
        console.error('Yandex Metrika is not initialized');
      }
}, []);

  return (
    <div className={styles.app} >
      <Snowfall 
      snowflakeCount={500}
      radius={[0.5, 7]}
      wind={[-1, 4]}
      speed={[0, 4]}
      rotationSpeed={[-1, 1]}
      />
      <Envelope />
    </div>
  );
}

export default App;
